module.exports = __webpack_public_path__ + "images/5fc99140c3110bab50278026ba47dd26.png";